import { render, staticRenderFns } from "./ChatterFilter.vue?vue&type=template&id=80d01a3e&scoped=true"
import script from "./ChatterFilter.vue?vue&type=script&lang=js"
export * from "./ChatterFilter.vue?vue&type=script&lang=js"
import style1 from "./ChatterFilter.vue?vue&type=style&index=1&id=80d01a3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d01a3e",
  null
  
)

export default component.exports